unit View.Provedores.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls,
  UHelperServer, WEBLib.Lists, WEBLib.Grids, Grid.Plugins, System.StrUtils,
  UConstantes, UUtils, UWeb.Enum;

type
  TFViewProvedoresEdit = class(TForm)
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    btDelete: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbnome: TLabel;
    ednome: TDBEdit;
    lbhomologado: TLabel;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    XDataClientProvedoresGet: TXDataWebClient;
    XDataClientProvedoresDelete: TXDataWebClient;
    ProvedoresDataset: TXDataWebDataSet;
    ProvedoresDatasetid: TIntegerField;
    ProvedoresDatasetnome: TStringField;
    ProvedoresDatasethomologado: TBooleanField;
    ProvedoresDatasetinclusao: TDateTimeField;
    ProvedoresDatasetalteracao: TDateTimeField;
    cbhomologado: TDBCheckBox;
    pnlEspacoFormProvedor: TPanel;
    pnlCidadesProvedor: TPanel;
    dtsCidadesProvedor: TDataSource;
    cdsCidadesProvedor: TXDataWebDataSet;
    cbPageSizeCidadesProvedor: TComboBox;
    cidades_provedor_search: TEdit;
    btnCidadesProvedorTab: TButton;
    btnAdicionarCidadeProvedor: TButton;
    tblCidadesProvedor: TDBTableControl;
    tmrConsultaCidadesProvedor: TTimer;
    lbTotalCidadesProvedor: TLabel;
    wlcCidadesProvedor: TListControl;
    cdsCidadesProvedorID: TIntegerField;
    cdsCidadesProvedorNome: TStringField;
    cdsCidadesProvedorCodigoIBGE: TIntegerField;
    cdsCidadesProvedorufSigla: TXDataWebDatasetField;
    cdsCidadesProvedorprovedor_id: TIntegerField;
    pnlCidades: TPanel;
    dtsCidades: TDataSource;
    cdsCidades: TXDataWebDataSet;
    cbPageSizeCidades: TComboBox;
    cidades_search: TEdit;
    tblCidades: TDBTableControl;
    tmrConsultaCidades: TTimer;
    lbTotalCidades: TLabel;
    wlcCidades: TListControl;
    cdsCidadesID: TIntegerField;
    cdsCidadesNome: TStringField;
    cdsCidadesCodigoIBGE: TIntegerField;
    cdsCidadesufSigla: TXDataWebDatasetField;
    cdsCidadesprovedor_id: TIntegerField;
    cdsCidadesprovedornome2: TXDataWebDatasetField;
    procedure btCloseMessageClick(Sender: TObject);
    procedure btCancelClick(Sender: TObject);
    procedure btSaveClick(Sender: TObject);
    [async]
    procedure btDeleteClick(Sender: TObject); async;
    procedure XDataClientProvedoresGetLoad(Response: TXDataClientResponse);
    procedure XDataClientProvedoresDeleteLoad(Response: TXDataClientResponse);
    procedure XDataClientProvedoresDeleteError(Error: TXDataClientError);
    [async]
    procedure ProvedoresDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults); async;
    procedure WebFormCreate(Sender: TObject);
    procedure btnCidadesProvedorTabClick(Sender: TObject);
    procedure tblCidadesProvedorGetCellData(Sender: TObject; ACol,
      ARow: Integer; AField: TField; var AValue: string);
    procedure tblCidadesProvedorGetCellClass(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; var AClassName: string);
    procedure tblCidadesProvedorGetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string;
      AElement: TJSHTMLElementRecord);
    procedure btnAdicionarCidadeProvedorClick(Sender: TObject);
    procedure tblCidadesGetCellChildren(Sender: TObject; ACol, ARow: Integer;
      AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure tblCidadesGetCellClass(Sender: TObject; ACol, ARow: Integer;
      AField: TField; AValue: string; var AClassName: string);
    procedure tblCidadesGetCellData(Sender: TObject; ACol, ARow: Integer;
      AField: TField; var AValue: string);
    procedure tmrConsultaCidadesProvedorTimer(Sender: TObject);
    procedure tmrConsultaCidadesTimer(Sender: TObject);
    procedure cbPageSizeCidadesProvedorChange(Sender: TObject);
    procedure cbPageSizeCidadesChange(Sender: TObject);
    procedure cidades_provedor_searchKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure cidades_searchKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure cidades_provedor_searchKeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure cidades_searchKeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure cdsCidadesAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure cdsCidadesProvedorAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormShow(Sender: TObject);
    procedure ednomeClick(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    FCarregouCidadesProvedor,
    FCarregouCidades : Boolean;
    FGridPluginCidadesProvedor,
    FGridPluginCidades : TGridPlugin;
    FProvedorId : Integer;

    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    procedure HiddenNotification;
    procedure RecarregarCds;
    procedure SetDadosProvedor;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewProvedoresEdit: TFViewProvedoresEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewProvedoresEdit }

procedure TFViewProvedoresEdit.btSaveClick(Sender: TObject);
begin
  TUtils.LimparErrosClass;

  if Trim(ednome.Text) =  '' then
  begin
    TUtils.SetErroClass('view_provedores_form_lbnome', 'Informe o nome do provedor!');

    Exit;
  end;

  if ProvedoresDataset.State in dsEditModes then
  begin
    ProvedoresDataset.Post;
    ProvedoresDataset.ApplyUpdates;
  end
  else
    FShowListProc;
end;

procedure TFViewProvedoresEdit.cbPageSizeCidadesChange(Sender: TObject);
begin
  FGridPluginCidades.SetPageSize(StrToInt(cbPageSizeCidades.Text), True);
end;

procedure TFViewProvedoresEdit.cbPageSizeCidadesProvedorChange(Sender: TObject);
begin
  FGridPluginCidadesProvedor.SetPageSize(StrToInt(cbPageSizeCidadesProvedor.Text), True);
end;

procedure TFViewProvedoresEdit.cdsCidadesAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      if Pos('Duplicate entry', ResolveInfo.Error) > 0  then
        TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, 'Cidade já esta adicionada ao atual!')
      else
        ShowNotification(ResolveInfo.Error);

      Exit;
    end;

  end;

  TUtils.ChamarMensagemDialog(TTipoDialogo.SUCESSO, 'Cidade adicionada ao provedor atual com sucesso!');

  RecarregarCds;
end;

procedure TFViewProvedoresEdit.cdsCidadesProvedorAfterApplyUpdates(
  Sender: TDataSet; Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      ShowNotification(ResolveInfo.Error);

      Exit;
    end;

  end;

  TUtils.ChamarMensagemDialog(TTipoDialogo.SUCESSO, 'Cidade removida do provedor atual com sucesso!');

  RecarregarCds;
end;

procedure TFViewProvedoresEdit.cidades_provedor_searchKeyDown(Sender: TObject;
  var Key: Word; Shift: TShiftState);
begin
  tmrConsultaCidadesProvedor.Enabled := False;

  if Key = 13 then
  begin
    FGridPluginCidadesProvedor.SetFilterText(cidades_provedor_search.Text, True);
  end;
end;

procedure TFViewProvedoresEdit.cidades_provedor_searchKeyUp(Sender: TObject;
  var Key: Word; Shift: TShiftState);
begin
  tmrConsultaCidadesProvedor.Interval := FTimerConsulta;
  tmrConsultaCidadesProvedor.Enabled := True;
end;

procedure TFViewProvedoresEdit.cidades_searchKeyDown(Sender: TObject;
  var Key: Word; Shift: TShiftState);
begin
  tmrConsultaCidades.Enabled := False;

  if Key = 13 then
  begin
    FGridPluginCidades.SetFilterText(cidades_search.Text, True);
  end;
end;

procedure TFViewProvedoresEdit.cidades_searchKeyUp(Sender: TObject;
  var Key: Word; Shift: TShiftState);
begin
  tmrConsultaCidades.Interval := FTimerConsulta;
  tmrConsultaCidades.Enabled := True;
end;

procedure TFViewProvedoresEdit.btDeleteClick(Sender: TObject);
begin
   if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO, 'Tem certeza que deseja '+
    'excluir este provedor?')) then
  begin
    if ProvedoresDataset.State in dsEditModes then
      ProvedoresDataset.Post;

    XDataClientProvedoresDelete.Delete(ProvedoresDataset.EntitySetName,
      TJSObject(ProvedoresDataset.CurrentData));
  end;
end;


procedure TFViewProvedoresEdit.btnAdicionarCidadeProvedorClick(Sender: TObject);
begin
  if not FCarregouCidades then
  begin
    FGridPluginCidades := TGridPlugin.Create(tblCidades, cdsCidades, wlcCidades,
      lbTotalCidades);

    FGridPluginCidades.FDatasetPlugin.FFilterPadrao := '(provedor_id ne ' + FProvedorId.ToString +
      ' or provedor_id eq null)';
    FGridPluginCidades.FDatasetPlugin.FOrderByPadrao := 'Nome asc';
    FGridPluginCidades.SetPageSize(StrToInt(cbPageSizeCidades.Text));
    FGridPluginCidades.SetFilterText(cidades_search.Text);
    FGridPluginCidades.Load;

    FCarregouCidades := True;
  end;
end;

procedure TFViewProvedoresEdit.btnCidadesProvedorTabClick(Sender: TObject);
begin
  if not FCarregouCidadesProvedor then
  begin
    FGridPluginCidadesProvedor := TGridPlugin.Create(
      tblCidadesProvedor,
      cdsCidadesProvedor,
      wlcCidadesProvedor,
      lbTotalCidadesProvedor
    );

    FGridPluginCidadesProvedor.FDatasetPlugin.FFilterPadrao := 'provedor_id eq ' + FProvedorId.ToString;
    FGridPluginCidadesProvedor.FDatasetPlugin.FOrderByPadrao := 'Nome asc';
    FGridPluginCidadesProvedor.SetPageSize(StrToInt(cbPageSizeCidadesProvedor.Text));
    FGridPluginCidadesProvedor.SetFilterText(cidades_provedor_search.Text);
    FGridPluginCidadesProvedor.Load;

    FCarregouCidadesProvedor := True;
  end;
end;

class function TFViewProvedoresEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewProvedoresEdit.ednomeClick(Sender: TObject);
begin
  TUtils.RemoverErroClass('view_provedores_form_lbnome');
end;

procedure TFViewProvedoresEdit.HiddenNotification;
begin
  //
end;

procedure TFViewProvedoresEdit.InsertEntity;
begin
  ProvedoresDataset.Close;
  ProvedoresDataset.SetJsonData('{}');
  ProvedoresDataset.Open;
  ProvedoresDataset.Insert;
end;

class function TFViewProvedoresEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewProvedoresEdit(AForm).FInserting := AInserting;
    TFViewProvedoresEdit(AForm).FId := AId;
    TFViewProvedoresEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewProvedoresEdit(AForm).InsertEntity
    else
      TFViewProvedoresEdit(AForm).LoadEntity;
    TFViewProvedoresEdit(AForm).btDelete.Enabled := not AInserting;
  end;

begin
  Application.CreateForm(TFViewProvedoresEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewProvedoresEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    ProvedoresDataset.Connection.Model.DefaultSchema.FindEntityType(
      ProvedoresDataset.EntitySetName
    )
  );
  XDataClientProvedoresGet.Get(ProvedoresDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewProvedoresEdit.SetDadosProvedor;
begin
  XDataClientProvedoresGet.Get(ProvedoresDataset.EntitySetName, FProvedorId);
  FInserting := False;
  btnCidadesProvedorTab.Visible := True;
  btnCidadesProvedorTab.Enabled := True;

  btnCidadesProvedorTab.Click;

  asm
    $('.div_alteracao').css('display', 'block');
    $('#line-cidades-tab').tab('show');
  end;

  ProvedoresDataset.Edit;
end;

procedure TFViewProvedoresEdit.ShowNotification(Notification: string);
begin
  TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, Notification);
end;

procedure TFViewProvedoresEdit.tblCidadesGetCellChildren(Sender: TObject; ACol,
  ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordNome,
  RecordProvedorNome : string;
  RecordId : Integer;
  [async]
  procedure AdicionarCidadeButtonClick(Sender: TObject); async;
  var
    lMensagem : string;
  begin
    if RecordProvedorNome = 'null' then
      lMensagem := 'Tem certeza que deseja adicionar a cidade <b>'+RecordNome+ '</b> ao provedor atual?'
    else
      lMensagem := 'A cidade <b>'+RecordNome+ '</b> está vinculada ao provedor <b>'+RecordProvedorNome+ '!</b>' +
        sLineBreak + 'Deseja alterá-la para o provedor atual?';

    if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO, lMensagem)) then
    begin
      if cdsCidades.Locate('ID', RecordId,[loCaseInsensitive,loPartialKey]) then
      begin
        cdsCidades.Edit;
        cdsCidades.FieldByName('provedor_id').Value := StrToInt(edid.Text);
        cdsCidades.Post;
        cdsCidades.ApplyUpdates;
      end;
    end;
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if (tblCidades.Columns[ACol].Title = 'Ação')  then
  begin
    RecordNome := cdsCidades.FieldByName('Nome').AsString;
    RecordId := cdsCidades.FieldByName('ID').AsInteger;
    RecordProvedorNome := cdsCidades.FieldByName('provedor.nome').AsString;

    Button := TButton.Create(nil);
    Button.Caption := '<i class="fas fa-plus-circle"></i>';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.setAttribute('data-test', 'btn_vincular_cidade_provedor');

    if TUtils.PossuiPermissao('cidade', TTipoPermissao.ALTERAR) then
    begin
      Button.OnClick := @AdicionarCidadeButtonClick;
      Button.ElementClassName := 'btn btn-link btn-primary btn-lg';
    end
    else
    begin
      Button.ElementClassName := 'btn btn-link text-muted btn-lg';
      Button.ElementHandle.style.setProperty('cursor', 'not-allowed');
    end;
  end;
end;

procedure TFViewProvedoresEdit.tblCidadesProvedorGetCellChildren(
  Sender: TObject; ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordCidadeId: Integer;
  RecordNome : string;
  [async]
  procedure RemoverCidadeButtonClick(Sender: TObject); async;
  begin
    if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO, 'Tem certeza que deseja remover a cidade <b>'
      +RecordNome+ '</b> do provedor atual?')) then
    begin
      if cdsCidadesProvedor.Locate('ID', RecordCidadeId,[loCaseInsensitive,loPartialKey]) then
      begin
        cdsCidadesProvedor.Edit;
        cdsCidadesProvedor.FieldByName('provedor_id').Value := null;
        cdsCidadesProvedor.Post;
        cdsCidadesProvedor.ApplyUpdates;
      end;
    end;
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if (tblCidadesProvedor.Columns[ACol].Title = 'Ação')  then
  begin
    RecordNome := cdsCidadesProvedor.FieldByName('Nome').AsString;
    RecordCidadeId := cdsCidadesProvedor.FieldByName('ID').AsInteger;

    Button := TButton.Create(nil);
    Button.Caption := '<i class="fas fa-minus-circle"></i>';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;

    if TUtils.PossuiPermissao('cidade', TTipoPermissao.ALTERAR) then
    begin
      Button.OnClick := @RemoverCidadeButtonClick;
      Button.ElementClassName := 'btn btn-link btn-danger btn-lg';
      Button.ElementHandle.setAttribute('data-test', 'btn_desvincular_cidade_provedor');
    end
    else
    begin
      Button.ElementClassName := 'btn btn-link text-muted btn-lg';
      Button.ElementHandle.style.setProperty('cursor', 'not-allowed');
    end;
  end;
end;

procedure TFViewProvedoresEdit.tblCidadesProvedorGetCellClass(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string; var AClassName: string);
begin
  if not FCarregouCidadesProvedor then
    Exit;

  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(tblCidadesProvedor.Columns[ACol].Title, ['Nome']) of
      0 : AClassName := 'text-left';
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewProvedoresEdit.tblCidadesProvedorGetCellData(Sender: TObject;
  ACol, ARow: Integer; AField: TField; var AValue: string);
begin
  if ARow > 0 then
  begin
    case IndexStr(tblCidadesProvedor.Columns[ACol].DataField, ['Nome']) of
      0:  AValue := AValue + ' - ' + cdsCidadesProvedor.FieldByName('uf.Sigla').AsString;
    end;
  end;
end;

procedure TFViewProvedoresEdit.tmrConsultaCidadesProvedorTimer(Sender: TObject);
begin
  FGridPluginCidadesProvedor.SetFilterText(cidades_provedor_search.Text, True);

  tmrConsultaCidadesProvedor.Enabled := False;
  tmrConsultaCidadesProvedor.Interval := FTimerConsulta;
end;

procedure TFViewProvedoresEdit.tmrConsultaCidadesTimer(Sender: TObject);
begin
  FGridPluginCidades.SetFilterText(cidades_search.Text, True);

  tmrConsultaCidades.Enabled := False;
  tmrConsultaCidades.Interval := FTimerConsulta;
end;

procedure TFViewProvedoresEdit.btCloseMessageClick(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewProvedoresEdit.WebFormCreate(Sender: TObject);
begin
  FCarregouCidadesProvedor := False;
  FCarregouCidades := False;
  HiddenNotification;
end;

procedure TFViewProvedoresEdit.WebFormShow(Sender: TObject);
begin
  if FInserting then
  begin
    TUtils.RemoverElementoPorId(btDelete.ElementID);

    asm
      $('.div_alteracao').css('display', 'none');
    end;

    btnCidadesProvedorTab.Visible := False;
    btnCidadesProvedorTab.Enabled := False;

    if ednome.CanFocus then
      ednome.SetFocus;
  end
  else
  begin
    if not TUtils.PossuiPermissao(ProvedoresDataset.EntitySetName.ToLower, TTipoPermissao.ALTERAR) then
    begin
      ednome.Enabled := False;
      cbhomologado.Enabled := False;
      btSave.Enabled := False;
    end;

    if not TUtils.PossuiPermissao(ProvedoresDataset.EntitySetName.ToLower, TTipoPermissao.EXCLUIR) then
      btDelete.Enabled := False;

    if not TUtils.PossuiPermissao('cidade', TTipoPermissao.VISUALIZAR) then
    begin
      TUtils.RemoverElementoPorId('modal_cidades');
      TUtils.RemoverElementoPorId(btnCidadesProvedorTab.ElementID);
      TUtils.RemoverElementoPorId('line-cidades');
    end;
  end;
end;

procedure TFViewProvedoresEdit.XDataClientProvedoresGetLoad(Response: TXDataClientResponse);
begin
  ProvedoresDataset.Close;
  ProvedoresDataset.SetJsonData(Response.Result);
  ProvedoresDataset.Open;

  ProvedoresDataset.Edit;

  FProvedorId := StrToInt(edid.Text);
end;

procedure TFViewProvedoresEdit.XDataClientProvedoresDeleteError(
  Error: TXDataClientError);
begin
  ShowNotification(Error.ErrorMessage);
end;

procedure TFViewProvedoresEdit.XDataClientProvedoresDeleteLoad(
  Response: TXDataClientResponse);
begin
  TUtils.ChamarMensagemDialog(TTipoDialogo.SUCESSO, 'Provedor excluído com sucesso!');
  FShowListProc;
end;

procedure TFViewProvedoresEdit.ProvedoresDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  ResolveInfo: TResolveInfo;
  I : Integer;
  lDataObject: TJSObject;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];

     if ResolveInfo.Error <> '' then
    begin
      if Pos('Duplicate entry', ResolveInfo.Error) > 0  then
        TUtils.SetErroClass('view_provedores_form_lbnome', 'Já existe algum provedor cadastrado com este nome!')
      else
        ShowNotification(ResolveInfo.Error);

      ProvedoresDataset.Edit;

      Exit;
    end;
  end;

  if FInserting then
  begin
    if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO,'Provedor cadastrado com sucesso!' + sLineBreak +
      'Deseja inserir as cidades vinculadas a ele?')) then
    begin
      lDataObject := TJSObject(ResolveInfo.Data);
      FProvedorId := Integer(lDataObject.Properties['id']);

      SetDadosProvedor;
    end
    else
      FShowListProc;
  end
  else
  begin
    TUtils.ChamarMensagemDialog(TTipoDialogo.SUCESSO, 'Provedor atualizado com sucesso!');
    FShowListProc;
  end;
end;

procedure TFViewProvedoresEdit.RecarregarCds;
begin
  FGridPluginCidades.Load;
  FGridPluginCidadesProvedor.Load;
end;

procedure TFViewProvedoresEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewProvedoresEdit.tblCidadesGetCellClass(Sender: TObject; ACol,
  ARow: Integer; AField: TField; AValue: string; var AClassName: string);
begin
  if not FCarregouCidades then
    Exit;

  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(tblCidades.Columns[ACol].Title, ['Nome', 'provedor.nome']) of
      0, 1 : AClassName := 'text-left';
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewProvedoresEdit.tblCidadesGetCellData(Sender: TObject; ACol,
  ARow: Integer; AField: TField; var AValue: string);
begin
  if ARow > 0 then
  begin
    case IndexStr(tblCidades.Columns[ACol].DataField, ['Nome', 'provedor.nome']) of
      0:  AValue := AValue + ' - ' + cdsCidades.FieldByName('uf.Sigla').AsString;
      1:
      begin
        if AValue = 'null' then
          AValue := '';
      end;
    end;
  end;
end;

procedure TFViewProvedoresEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbid := TLabel.Create('view.provedores.form.lbid');
  lbnome := TLabel.Create('view.provedores.form.lbnome');
  lbhomologado := TLabel.Create('view.provedores.form.lbhomologado');
  lbinclusao := TLabel.Create('view.provedores.form.lbinclusao');
  lbalteracao := TLabel.Create('view.provedores.form.lbalteracao');
  lbTotalCidadesProvedor := TLabel.Create('cidades_provedor_paginacao_info');
  lbTotalCidades := TLabel.Create('cidades_paginacao_info');
  btCancel := TButton.Create('view.provedores.form.btBack');
  btSave := TButton.Create('view.provedores.form.btSave');
  btDelete := TButton.Create('view.provedores.form.btDelete');
  edid := TDBEdit.Create('view.provedores.form.edid');
  ednome := TDBEdit.Create('view.provedores.form.ednome');
  edinclusao := TDBEdit.Create('view.provedores.form.edinclusao');
  edalteracao := TDBEdit.Create('view.provedores.form.edalteracao');
  cbhomologado := TDBCheckBox.Create('view.provedores.form.cbhomologado');
  pnlEspacoFormProvedor := TPanel.Create(Self);
  pnlCidadesProvedor := TPanel.Create(Self);
  cbPageSizeCidadesProvedor := TComboBox.Create('cidades_provedor_page_size');
  cidades_provedor_search := TEdit.Create('cidades_provedor_search');
  btnCidadesProvedorTab := TButton.Create('line-cidades-tab');
  btnAdicionarCidadeProvedor := TButton.Create('btn_add_cidade_provedor');
  tblCidadesProvedor := TDBTableControl.Create('cidades_provedor_table');
  wlcCidadesProvedor := TListControl.Create('cidades_provedor_list_paginacao');
  pnlCidades := TPanel.Create(Self);
  cbPageSizeCidades := TComboBox.Create('cidades_page_size');
  cidades_search := TEdit.Create('cidades_search');
  tblCidades := TDBTableControl.Create('cidades_table');
  wlcCidades := TListControl.Create('cidades_list_paginacao');
  DataSource := TDataSource.Create(Self);
  ProvedoresDataset := TXDataWebDataSet.Create(Self);
  ProvedoresDatasetid := TIntegerField.Create(Self);
  ProvedoresDatasetnome := TStringField.Create(Self);
  ProvedoresDatasethomologado := TBooleanField.Create(Self);
  ProvedoresDatasetinclusao := TDateTimeField.Create(Self);
  ProvedoresDatasetalteracao := TDateTimeField.Create(Self);
  XDataClientProvedoresGet := TXDataWebClient.Create(Self);
  XDataClientProvedoresDelete := TXDataWebClient.Create(Self);
  dtsCidadesProvedor := TDataSource.Create(Self);
  cdsCidadesProvedor := TXDataWebDataSet.Create(Self);
  cdsCidadesProvedorID := TIntegerField.Create(Self);
  cdsCidadesProvedorNome := TStringField.Create(Self);
  cdsCidadesProvedorCodigoIBGE := TIntegerField.Create(Self);
  cdsCidadesProvedorufSigla := TXDataWebDatasetField.Create(Self);
  cdsCidadesProvedorprovedor_id := TIntegerField.Create(Self);
  tmrConsultaCidadesProvedor := TTimer.Create(Self);
  dtsCidades := TDataSource.Create(Self);
  cdsCidades := TXDataWebDataSet.Create(Self);
  cdsCidadesID := TIntegerField.Create(Self);
  cdsCidadesNome := TStringField.Create(Self);
  cdsCidadesCodigoIBGE := TIntegerField.Create(Self);
  cdsCidadesufSigla := TXDataWebDatasetField.Create(Self);
  cdsCidadesprovedor_id := TIntegerField.Create(Self);
  cdsCidadesprovedornome2 := TXDataWebDatasetField.Create(Self);
  tmrConsultaCidades := TTimer.Create(Self);

  lbid.BeforeLoadDFMValues;
  lbnome.BeforeLoadDFMValues;
  lbhomologado.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  lbTotalCidadesProvedor.BeforeLoadDFMValues;
  lbTotalCidades.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  btDelete.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  ednome.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  cbhomologado.BeforeLoadDFMValues;
  pnlEspacoFormProvedor.BeforeLoadDFMValues;
  pnlCidadesProvedor.BeforeLoadDFMValues;
  cbPageSizeCidadesProvedor.BeforeLoadDFMValues;
  cidades_provedor_search.BeforeLoadDFMValues;
  btnCidadesProvedorTab.BeforeLoadDFMValues;
  btnAdicionarCidadeProvedor.BeforeLoadDFMValues;
  tblCidadesProvedor.BeforeLoadDFMValues;
  wlcCidadesProvedor.BeforeLoadDFMValues;
  pnlCidades.BeforeLoadDFMValues;
  cbPageSizeCidades.BeforeLoadDFMValues;
  cidades_search.BeforeLoadDFMValues;
  tblCidades.BeforeLoadDFMValues;
  wlcCidades.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  ProvedoresDataset.BeforeLoadDFMValues;
  ProvedoresDatasetid.BeforeLoadDFMValues;
  ProvedoresDatasetnome.BeforeLoadDFMValues;
  ProvedoresDatasethomologado.BeforeLoadDFMValues;
  ProvedoresDatasetinclusao.BeforeLoadDFMValues;
  ProvedoresDatasetalteracao.BeforeLoadDFMValues;
  XDataClientProvedoresGet.BeforeLoadDFMValues;
  XDataClientProvedoresDelete.BeforeLoadDFMValues;
  dtsCidadesProvedor.BeforeLoadDFMValues;
  cdsCidadesProvedor.BeforeLoadDFMValues;
  cdsCidadesProvedorID.BeforeLoadDFMValues;
  cdsCidadesProvedorNome.BeforeLoadDFMValues;
  cdsCidadesProvedorCodigoIBGE.BeforeLoadDFMValues;
  cdsCidadesProvedorufSigla.BeforeLoadDFMValues;
  cdsCidadesProvedorprovedor_id.BeforeLoadDFMValues;
  tmrConsultaCidadesProvedor.BeforeLoadDFMValues;
  dtsCidades.BeforeLoadDFMValues;
  cdsCidades.BeforeLoadDFMValues;
  cdsCidadesID.BeforeLoadDFMValues;
  cdsCidadesNome.BeforeLoadDFMValues;
  cdsCidadesCodigoIBGE.BeforeLoadDFMValues;
  cdsCidadesufSigla.BeforeLoadDFMValues;
  cdsCidadesprovedor_id.BeforeLoadDFMValues;
  cdsCidadesprovedornome2.BeforeLoadDFMValues;
  tmrConsultaCidades.BeforeLoadDFMValues;
  try
    Name := 'FViewProvedoresEdit';
    Width := 706;
    Height := 638;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 9;
    lbid.Top := 34;
    lbid.Width := 23;
    lbid.Height := 13;
    lbid.Caption := 'C'#243'd:';
    lbid.HeightPercent := 100.000000000000000000;
    lbid.WidthPercent := 100.000000000000000000;
    lbnome.SetParentComponent(Self);
    lbnome.Name := 'lbnome';
    lbnome.Left := 9;
    lbnome.Top := 61;
    lbnome.Width := 31;
    lbnome.Height := 13;
    lbnome.Caption := 'Nome:';
    lbnome.HeightPercent := 100.000000000000000000;
    lbnome.WidthPercent := 100.000000000000000000;
    lbhomologado.SetParentComponent(Self);
    lbhomologado.Name := 'lbhomologado';
    lbhomologado.Left := 9;
    lbhomologado.Top := 88;
    lbhomologado.Width := 64;
    lbhomologado.Height := 13;
    lbhomologado.Caption := 'Homologado?';
    lbhomologado.HeightPercent := 100.000000000000000000;
    lbhomologado.WidthPercent := 100.000000000000000000;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 9;
    lbinclusao.Top := 115;
    lbinclusao.Width := 44;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'Inclus'#227'o:';
    lbinclusao.HeightPercent := 100.000000000000000000;
    lbinclusao.WidthPercent := 100.000000000000000000;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 9;
    lbalteracao.Top := 142;
    lbalteracao.Width := 50;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'Altera'#231#227'o:';
    lbalteracao.HeightPercent := 100.000000000000000000;
    lbalteracao.WidthPercent := 100.000000000000000000;
    lbTotalCidadesProvedor.SetParentComponent(Self);
    lbTotalCidadesProvedor.Name := 'lbTotalCidadesProvedor';
    lbTotalCidadesProvedor.Left := 344;
    lbTotalCidadesProvedor.Top := 239;
    lbTotalCidadesProvedor.Width := 141;
    lbTotalCidadesProvedor.Height := 13;
    lbTotalCidadesProvedor.Caption := 'Showing 1 to 10 of 57 entries';
    lbTotalCidadesProvedor.HeightPercent := 100.000000000000000000;
    lbTotalCidadesProvedor.WidthPercent := 100.000000000000000000;
    lbTotalCidades.SetParentComponent(Self);
    lbTotalCidades.Name := 'lbTotalCidades';
    lbTotalCidades.Left := 8;
    lbTotalCidades.Top := 503;
    lbTotalCidades.Width := 141;
    lbTotalCidades.Height := 13;
    lbTotalCidades.Caption := 'Showing 1 to 10 of 57 entries';
    lbTotalCidades.HeightPercent := 100.000000000000000000;
    lbTotalCidades.WidthPercent := 100.000000000000000000;
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 217;
    btCancel.Top := 62;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancel';
    btCancel.HeightPercent := 100.000000000000000000;
    btCancel.TabOrder := 1;
    btCancel.WidthPercent := 100.000000000000000000;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 217;
    btSave.Top := 31;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Save';
    btSave.HeightPercent := 100.000000000000000000;
    btSave.TabOrder := 4;
    btSave.WidthPercent := 100.000000000000000000;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    btDelete.SetParentComponent(Self);
    btDelete.Name := 'btDelete';
    btDelete.Left := 217;
    btDelete.Top := 93;
    btDelete.Width := 96;
    btDelete.Height := 25;
    btDelete.Caption := 'Delete';
    btDelete.HeightPercent := 100.000000000000000000;
    btDelete.TabOrder := 5;
    btDelete.WidthPercent := 100.000000000000000000;
    SetEvent(btDelete, Self, 'OnClick', 'btDeleteClick');
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 86;
    edid.Top := 31;
    edid.Width := 99;
    edid.Height := 21;
    edid.Enabled := False;
    edid.HeightPercent := 100.000000000000000000;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.WidthPercent := 100.000000000000000000;
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    ednome.SetParentComponent(Self);
    ednome.Name := 'ednome';
    ednome.Left := 86;
    ednome.Top := 58;
    ednome.Width := 99;
    ednome.Height := 21;
    ednome.HeightPercent := 100.000000000000000000;
    ednome.TabOrder := 7;
    ednome.Text := 'ednome';
    ednome.WidthPercent := 100.000000000000000000;
    SetEvent(ednome, Self, 'OnClick', 'ednomeClick');
    ednome.DataField := 'nome';
    ednome.DataSource := DataSource;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 86;
    edinclusao.Top := 112;
    edinclusao.Width := 99;
    edinclusao.Height := 21;
    edinclusao.Enabled := False;
    edinclusao.HeightPercent := 100.000000000000000000;
    edinclusao.TabOrder := 9;
    edinclusao.Text := 'edinclusao';
    edinclusao.WidthPercent := 100.000000000000000000;
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 86;
    edalteracao.Top := 139;
    edalteracao.Width := 99;
    edalteracao.Height := 21;
    edalteracao.Enabled := False;
    edalteracao.HeightPercent := 100.000000000000000000;
    edalteracao.TabOrder := 10;
    edalteracao.Text := 'edalteracao';
    edalteracao.WidthPercent := 100.000000000000000000;
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    cbhomologado.SetParentComponent(Self);
    cbhomologado.Name := 'cbhomologado';
    cbhomologado.Left := 86;
    cbhomologado.Top := 85;
    cbhomologado.Width := 99;
    cbhomologado.Height := 22;
    cbhomologado.Caption := 'cbhomologado';
    cbhomologado.ChildOrder := 13;
    cbhomologado.HeightPercent := 100.000000000000000000;
    cbhomologado.WidthPercent := 100.000000000000000000;
    cbhomologado.DataField := 'homologado';
    cbhomologado.DataSource := DataSource;
    pnlEspacoFormProvedor.SetParentComponent(Self);
    pnlEspacoFormProvedor.Name := 'pnlEspacoFormProvedor';
    pnlEspacoFormProvedor.Left := 8;
    pnlEspacoFormProvedor.Top := 8;
    pnlEspacoFormProvedor.Width := 305;
    pnlEspacoFormProvedor.Height := 17;
    pnlEspacoFormProvedor.Caption := 'Espa'#231'o form Provedor';
    pnlEspacoFormProvedor.ChildOrder := 23;
    pnlEspacoFormProvedor.Color := clInfoText;
    pnlEspacoFormProvedor.Font.Charset := DEFAULT_CHARSET;
    pnlEspacoFormProvedor.Font.Color := clWhite;
    pnlEspacoFormProvedor.Font.Height := -11;
    pnlEspacoFormProvedor.Font.Name := 'Tahoma';
    pnlEspacoFormProvedor.Font.Style := [fsBold];
    pnlEspacoFormProvedor.ParentFont := False;
    pnlEspacoFormProvedor.TabOrder := 8;
    pnlEspacoFormProvedor.Visible := False;
    pnlCidadesProvedor.SetParentComponent(Self);
    pnlCidadesProvedor.Name := 'pnlCidadesProvedor';
    pnlCidadesProvedor.Left := 336;
    pnlCidadesProvedor.Top := 8;
    pnlCidadesProvedor.Width := 343;
    pnlCidadesProvedor.Height := 17;
    pnlCidadesProvedor.Caption := 'Espa'#231'o tabela cidades provedor';
    pnlCidadesProvedor.ChildOrder := 23;
    pnlCidadesProvedor.Color := clInfoText;
    pnlCidadesProvedor.Font.Charset := DEFAULT_CHARSET;
    pnlCidadesProvedor.Font.Color := clWhite;
    pnlCidadesProvedor.Font.Height := -11;
    pnlCidadesProvedor.Font.Name := 'Tahoma';
    pnlCidadesProvedor.Font.Style := [fsBold];
    pnlCidadesProvedor.ParentFont := False;
    pnlCidadesProvedor.TabOrder := 9;
    pnlCidadesProvedor.Visible := False;
    cbPageSizeCidadesProvedor.SetParentComponent(Self);
    cbPageSizeCidadesProvedor.Name := 'cbPageSizeCidadesProvedor';
    cbPageSizeCidadesProvedor.Left := 488;
    cbPageSizeCidadesProvedor.Top := 31;
    cbPageSizeCidadesProvedor.Width := 81;
    cbPageSizeCidadesProvedor.Height := 21;
    cbPageSizeCidadesProvedor.HeightPercent := 100.000000000000000000;
    cbPageSizeCidadesProvedor.TabOrder := 2;
    cbPageSizeCidadesProvedor.Text := '10';
    cbPageSizeCidadesProvedor.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSizeCidadesProvedor, Self, 'OnChange', 'cbPageSizeCidadesProvedorChange');
    cbPageSizeCidadesProvedor.ItemIndex := 0;
    cbPageSizeCidadesProvedor.Items.BeginUpdate;
    try
      cbPageSizeCidadesProvedor.Items.Clear;
      cbPageSizeCidadesProvedor.Items.Add('10');
      cbPageSizeCidadesProvedor.Items.Add('25');
      cbPageSizeCidadesProvedor.Items.Add('50');
      cbPageSizeCidadesProvedor.Items.Add('100');
    finally
      cbPageSizeCidadesProvedor.Items.EndUpdate;
    end;
    cidades_provedor_search.SetParentComponent(Self);
    cidades_provedor_search.Name := 'cidades_provedor_search';
    cidades_provedor_search.Left := 488;
    cidades_provedor_search.Top := 58;
    cidades_provedor_search.Width := 81;
    cidades_provedor_search.Height := 21;
    cidades_provedor_search.ChildOrder := 21;
    cidades_provedor_search.HeightPercent := 100.000000000000000000;
    cidades_provedor_search.TabOrder := 3;
    cidades_provedor_search.WidthPercent := 100.000000000000000000;
    SetEvent(cidades_provedor_search, Self, 'OnKeyDown', 'cidades_provedor_searchKeyDown');
    SetEvent(cidades_provedor_search, Self, 'OnKeyUp', 'cidades_provedor_searchKeyUp');
    btnCidadesProvedorTab.SetParentComponent(Self);
    btnCidadesProvedorTab.Name := 'btnCidadesProvedorTab';
    btnCidadesProvedorTab.Left := 575;
    btnCidadesProvedorTab.Top := 31;
    btnCidadesProvedorTab.Width := 96;
    btnCidadesProvedorTab.Height := 25;
    btnCidadesProvedorTab.Caption := 'Cidades';
    btnCidadesProvedorTab.ChildOrder := 16;
    btnCidadesProvedorTab.HeightPercent := 100.000000000000000000;
    btnCidadesProvedorTab.WidthPercent := 100.000000000000000000;
    SetEvent(btnCidadesProvedorTab, Self, 'OnClick', 'btnCidadesProvedorTabClick');
    btnAdicionarCidadeProvedor.SetParentComponent(Self);
    btnAdicionarCidadeProvedor.Name := 'btnAdicionarCidadeProvedor';
    btnAdicionarCidadeProvedor.Left := 575;
    btnAdicionarCidadeProvedor.Top := 58;
    btnAdicionarCidadeProvedor.Width := 96;
    btnAdicionarCidadeProvedor.Height := 25;
    btnAdicionarCidadeProvedor.Caption := 'Adicionar Cidade';
    btnAdicionarCidadeProvedor.ChildOrder := 41;
    btnAdicionarCidadeProvedor.HeightPercent := 100.000000000000000000;
    btnAdicionarCidadeProvedor.WidthPercent := 100.000000000000000000;
    SetEvent(btnAdicionarCidadeProvedor, Self, 'OnClick', 'btnAdicionarCidadeProvedorClick');
    tblCidadesProvedor.SetParentComponent(Self);
    tblCidadesProvedor.Name := 'tblCidadesProvedor';
    tblCidadesProvedor.Left := 344;
    tblCidadesProvedor.Top := 88;
    tblCidadesProvedor.Width := 335;
    tblCidadesProvedor.Height := 143;
    tblCidadesProvedor.ElementClassName := 'table-responsive';
    tblCidadesProvedor.BorderColor := clSilver;
    tblCidadesProvedor.ChildOrder := 19;
    tblCidadesProvedor.ColHeader := False;
    tblCidadesProvedor.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(tblCidadesProvedor, Self, 'OnGetCellData', 'tblCidadesProvedorGetCellData');
    SetEvent(tblCidadesProvedor, Self, 'OnGetCellChildren', 'tblCidadesProvedorGetCellChildren');
    SetEvent(tblCidadesProvedor, Self, 'OnGetCellClass', 'tblCidadesProvedorGetCellClass');
    tblCidadesProvedor.Columns.Clear;
    with tblCidadesProvedor.Columns.Add do
    begin
      Title := 'A'#231#227'o';
    end;
    with tblCidadesProvedor.Columns.Add do
    begin
      DataField := 'Nome';
      Title := 'Nome';
    end;
    with tblCidadesProvedor.Columns.Add do
    begin
      DataField := 'CodigoIBGE';
      Title := 'C'#243'd. IBGE';
    end;
    tblCidadesProvedor.DataSource := dtsCidadesProvedor;
    wlcCidadesProvedor.SetParentComponent(Self);
    wlcCidadesProvedor.Name := 'wlcCidadesProvedor';
    wlcCidadesProvedor.Left := 472;
    wlcCidadesProvedor.Top := 237;
    wlcCidadesProvedor.Width := 207;
    wlcCidadesProvedor.Height := 15;
    wlcCidadesProvedor.HeightPercent := 100.000000000000000000;
    wlcCidadesProvedor.WidthPercent := 100.000000000000000000;
    wlcCidadesProvedor.ChildOrder := 24;
    wlcCidadesProvedor.DefaultItemClassName := 'page-item';
    wlcCidadesProvedor.DefaultItemLinkClassName := 'page-link';
    wlcCidadesProvedor.ElementListClassName := 'pagination';
    wlcCidadesProvedor.Items.Clear;
    with wlcCidadesProvedor.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 0';
    end;
    with wlcCidadesProvedor.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 1';
    end;
    with wlcCidadesProvedor.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 2';
    end;
    wlcCidadesProvedor.Style := lsPagination;
    pnlCidades.SetParentComponent(Self);
    pnlCidades.Name := 'pnlCidades';
    pnlCidades.Left := 8;
    pnlCidades.Top := 272;
    pnlCidades.Width := 353;
    pnlCidades.Height := 17;
    pnlCidades.Caption := 'Espa'#231'o tabela cidades';
    pnlCidades.ChildOrder := 23;
    pnlCidades.Color := clInfoText;
    pnlCidades.Font.Charset := DEFAULT_CHARSET;
    pnlCidades.Font.Color := clWhite;
    pnlCidades.Font.Height := -11;
    pnlCidades.Font.Name := 'Tahoma';
    pnlCidades.Font.Style := [fsBold];
    pnlCidades.ParentFont := False;
    pnlCidades.TabOrder := 16;
    pnlCidades.Visible := False;
    cbPageSizeCidades.SetParentComponent(Self);
    cbPageSizeCidades.Name := 'cbPageSizeCidades';
    cbPageSizeCidades.Left := 160;
    cbPageSizeCidades.Top := 296;
    cbPageSizeCidades.Width := 81;
    cbPageSizeCidades.Height := 21;
    cbPageSizeCidades.HeightPercent := 100.000000000000000000;
    cbPageSizeCidades.TabOrder := 2;
    cbPageSizeCidades.Text := '10';
    cbPageSizeCidades.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSizeCidades, Self, 'OnChange', 'cbPageSizeCidadesChange');
    cbPageSizeCidades.ItemIndex := 0;
    cbPageSizeCidades.Items.BeginUpdate;
    try
      cbPageSizeCidades.Items.Clear;
      cbPageSizeCidades.Items.Add('10');
      cbPageSizeCidades.Items.Add('25');
      cbPageSizeCidades.Items.Add('50');
      cbPageSizeCidades.Items.Add('100');
    finally
      cbPageSizeCidades.Items.EndUpdate;
    end;
    cidades_search.SetParentComponent(Self);
    cidades_search.Name := 'cidades_search';
    cidades_search.Left := 160;
    cidades_search.Top := 323;
    cidades_search.Width := 81;
    cidades_search.Height := 21;
    cidades_search.ChildOrder := 21;
    cidades_search.HeightPercent := 100.000000000000000000;
    cidades_search.TabOrder := 3;
    cidades_search.WidthPercent := 100.000000000000000000;
    SetEvent(cidades_search, Self, 'OnKeyDown', 'cidades_searchKeyDown');
    SetEvent(cidades_search, Self, 'OnKeyUp', 'cidades_searchKeyUp');
    tblCidades.SetParentComponent(Self);
    tblCidades.Name := 'tblCidades';
    tblCidades.Left := 8;
    tblCidades.Top := 352;
    tblCidades.Width := 335;
    tblCidades.Height := 143;
    tblCidades.ElementClassName := 'table-responsive';
    tblCidades.BorderColor := clSilver;
    tblCidades.ChildOrder := 19;
    tblCidades.ColHeader := False;
    tblCidades.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(tblCidades, Self, 'OnGetCellData', 'tblCidadesGetCellData');
    SetEvent(tblCidades, Self, 'OnGetCellChildren', 'tblCidadesGetCellChildren');
    SetEvent(tblCidades, Self, 'OnGetCellClass', 'tblCidadesGetCellClass');
    tblCidades.Columns.Clear;
    with tblCidades.Columns.Add do
    begin
      Title := 'A'#231#227'o';
    end;
    with tblCidades.Columns.Add do
    begin
      DataField := 'Nome';
      Title := 'Nome';
    end;
    with tblCidades.Columns.Add do
    begin
      DataField := 'CodigoIBGE';
      Title := 'C'#243'd. IBGE';
    end;
    with tblCidades.Columns.Add do
    begin
      DataField := 'provedor.nome';
      Title := 'Provedor Atual';
    end;
    tblCidades.DataSource := dtsCidades;
    wlcCidades.SetParentComponent(Self);
    wlcCidades.Name := 'wlcCidades';
    wlcCidades.Left := 136;
    wlcCidades.Top := 501;
    wlcCidades.Width := 207;
    wlcCidades.Height := 15;
    wlcCidades.HeightPercent := 100.000000000000000000;
    wlcCidades.WidthPercent := 100.000000000000000000;
    wlcCidades.ChildOrder := 24;
    wlcCidades.DefaultItemClassName := 'page-item';
    wlcCidades.DefaultItemLinkClassName := 'page-link';
    wlcCidades.ElementListClassName := 'pagination';
    wlcCidades.Items.Clear;
    with wlcCidades.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 0';
    end;
    with wlcCidades.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 1';
    end;
    with wlcCidades.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 2';
    end;
    wlcCidades.Style := lsPagination;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := ProvedoresDataset;
    DataSource.Left := 552;
    DataSource.Top := 368;
    ProvedoresDataset.SetParentComponent(Self);
    ProvedoresDataset.Name := 'ProvedoresDataset';
    ProvedoresDataset.AfterApplyUpdates := ProvedoresDatasetAfterApplyUpdates;
    ProvedoresDataset.EntitySetName := 'Provedores';
    ProvedoresDataset.Connection := DMConnection.ApiConnection;
    ProvedoresDataset.Left := 544;
    ProvedoresDataset.Top := 296;
    ProvedoresDatasetid.SetParentComponent(ProvedoresDataset);
    ProvedoresDatasetid.Name := 'ProvedoresDatasetid';
    ProvedoresDatasetid.FieldName := 'id';
    ProvedoresDatasetnome.SetParentComponent(ProvedoresDataset);
    ProvedoresDatasetnome.Name := 'ProvedoresDatasetnome';
    ProvedoresDatasetnome.FieldName := 'nome';
    ProvedoresDatasetnome.Required := True;
    ProvedoresDatasetnome.Size := 255;
    ProvedoresDatasethomologado.SetParentComponent(ProvedoresDataset);
    ProvedoresDatasethomologado.Name := 'ProvedoresDatasethomologado';
    ProvedoresDatasethomologado.FieldName := 'homologado';
    ProvedoresDatasetinclusao.SetParentComponent(ProvedoresDataset);
    ProvedoresDatasetinclusao.Name := 'ProvedoresDatasetinclusao';
    ProvedoresDatasetinclusao.FieldName := 'inclusao';
    ProvedoresDatasetinclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    ProvedoresDatasetalteracao.SetParentComponent(ProvedoresDataset);
    ProvedoresDatasetalteracao.Name := 'ProvedoresDatasetalteracao';
    ProvedoresDatasetalteracao.FieldName := 'alteracao';
    ProvedoresDatasetalteracao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    XDataClientProvedoresGet.SetParentComponent(Self);
    XDataClientProvedoresGet.Name := 'XDataClientProvedoresGet';
    XDataClientProvedoresGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientProvedoresGet, Self, 'OnLoad', 'XDataClientProvedoresGetLoad');
    XDataClientProvedoresGet.Left := 424;
    XDataClientProvedoresGet.Top := 296;
    XDataClientProvedoresDelete.SetParentComponent(Self);
    XDataClientProvedoresDelete.Name := 'XDataClientProvedoresDelete';
    XDataClientProvedoresDelete.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientProvedoresDelete, Self, 'OnLoad', 'XDataClientProvedoresDeleteLoad');
    SetEvent(XDataClientProvedoresDelete, Self, 'OnError', 'XDataClientProvedoresDeleteError');
    XDataClientProvedoresDelete.Left := 432;
    XDataClientProvedoresDelete.Top := 376;
    dtsCidadesProvedor.SetParentComponent(Self);
    dtsCidadesProvedor.Name := 'dtsCidadesProvedor';
    dtsCidadesProvedor.DataSet := cdsCidadesProvedor;
    dtsCidadesProvedor.Left := 352;
    dtsCidadesProvedor.Top := 40;
    cdsCidadesProvedor.SetParentComponent(Self);
    cdsCidadesProvedor.Name := 'cdsCidadesProvedor';
    cdsCidadesProvedor.AfterApplyUpdates := cdsCidadesProvedorAfterApplyUpdates;
    cdsCidadesProvedor.EntitySetName := 'Cidade';
    cdsCidadesProvedor.Connection := DMConnection.ApiConnection;
    cdsCidadesProvedor.Left := 424;
    cdsCidadesProvedor.Top := 40;
    cdsCidadesProvedorID.SetParentComponent(cdsCidadesProvedor);
    cdsCidadesProvedorID.Name := 'cdsCidadesProvedorID';
    cdsCidadesProvedorID.FieldName := 'ID';
    cdsCidadesProvedorID.Required := True;
    cdsCidadesProvedorNome.SetParentComponent(cdsCidadesProvedor);
    cdsCidadesProvedorNome.Name := 'cdsCidadesProvedorNome';
    cdsCidadesProvedorNome.FieldName := 'Nome';
    cdsCidadesProvedorNome.Required := True;
    cdsCidadesProvedorNome.Size := 255;
    cdsCidadesProvedorCodigoIBGE.SetParentComponent(cdsCidadesProvedor);
    cdsCidadesProvedorCodigoIBGE.Name := 'cdsCidadesProvedorCodigoIBGE';
    cdsCidadesProvedorCodigoIBGE.FieldName := 'CodigoIBGE';
    cdsCidadesProvedorCodigoIBGE.Required := True;
    cdsCidadesProvedorufSigla.SetParentComponent(cdsCidadesProvedor);
    cdsCidadesProvedorufSigla.Name := 'cdsCidadesProvedorufSigla';
    cdsCidadesProvedorufSigla.FieldKind := fkCalculated;
    cdsCidadesProvedorufSigla.FieldName := 'uf.Sigla';
    cdsCidadesProvedorufSigla.Calculated := True;
    cdsCidadesProvedorprovedor_id.SetParentComponent(cdsCidadesProvedor);
    cdsCidadesProvedorprovedor_id.Name := 'cdsCidadesProvedorprovedor_id';
    cdsCidadesProvedorprovedor_id.FieldName := 'provedor_id';
    tmrConsultaCidadesProvedor.SetParentComponent(Self);
    tmrConsultaCidadesProvedor.Name := 'tmrConsultaCidadesProvedor';
    tmrConsultaCidadesProvedor.Enabled := False;
    SetEvent(tmrConsultaCidadesProvedor, Self, 'OnTimer', 'tmrConsultaCidadesProvedorTimer');
    tmrConsultaCidadesProvedor.Left := 408;
    tmrConsultaCidadesProvedor.Top := 128;
    dtsCidades.SetParentComponent(Self);
    dtsCidades.Name := 'dtsCidades';
    dtsCidades.DataSet := cdsCidades;
    dtsCidades.Left := 16;
    dtsCidades.Top := 304;
    cdsCidades.SetParentComponent(Self);
    cdsCidades.Name := 'cdsCidades';
    cdsCidades.AfterApplyUpdates := cdsCidadesAfterApplyUpdates;
    cdsCidades.EntitySetName := 'Cidade';
    cdsCidades.Connection := DMConnection.ApiConnection;
    cdsCidades.Left := 88;
    cdsCidades.Top := 304;
    cdsCidadesID.SetParentComponent(cdsCidades);
    cdsCidadesID.Name := 'cdsCidadesID';
    cdsCidadesID.FieldName := 'ID';
    cdsCidadesID.Required := True;
    cdsCidadesNome.SetParentComponent(cdsCidades);
    cdsCidadesNome.Name := 'cdsCidadesNome';
    cdsCidadesNome.FieldName := 'Nome';
    cdsCidadesNome.Required := True;
    cdsCidadesNome.Size := 255;
    cdsCidadesCodigoIBGE.SetParentComponent(cdsCidades);
    cdsCidadesCodigoIBGE.Name := 'cdsCidadesCodigoIBGE';
    cdsCidadesCodigoIBGE.FieldName := 'CodigoIBGE';
    cdsCidadesCodigoIBGE.Required := True;
    cdsCidadesufSigla.SetParentComponent(cdsCidades);
    cdsCidadesufSigla.Name := 'cdsCidadesufSigla';
    cdsCidadesufSigla.FieldKind := fkCalculated;
    cdsCidadesufSigla.FieldName := 'uf.Sigla';
    cdsCidadesufSigla.Calculated := True;
    cdsCidadesprovedor_id.SetParentComponent(cdsCidades);
    cdsCidadesprovedor_id.Name := 'cdsCidadesprovedor_id';
    cdsCidadesprovedor_id.FieldName := 'provedor_id';
    cdsCidadesprovedornome2.SetParentComponent(cdsCidades);
    cdsCidadesprovedornome2.Name := 'cdsCidadesprovedornome2';
    cdsCidadesprovedornome2.FieldKind := fkCalculated;
    cdsCidadesprovedornome2.FieldName := 'provedor.nome';
    cdsCidadesprovedornome2.Calculated := True;
    tmrConsultaCidades.SetParentComponent(Self);
    tmrConsultaCidades.Name := 'tmrConsultaCidades';
    tmrConsultaCidades.Enabled := False;
    SetEvent(tmrConsultaCidades, Self, 'OnTimer', 'tmrConsultaCidadesTimer');
    tmrConsultaCidades.Left := 47;
    tmrConsultaCidades.Top := 376;
  finally
    lbid.AfterLoadDFMValues;
    lbnome.AfterLoadDFMValues;
    lbhomologado.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    lbTotalCidadesProvedor.AfterLoadDFMValues;
    lbTotalCidades.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    btDelete.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    ednome.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    cbhomologado.AfterLoadDFMValues;
    pnlEspacoFormProvedor.AfterLoadDFMValues;
    pnlCidadesProvedor.AfterLoadDFMValues;
    cbPageSizeCidadesProvedor.AfterLoadDFMValues;
    cidades_provedor_search.AfterLoadDFMValues;
    btnCidadesProvedorTab.AfterLoadDFMValues;
    btnAdicionarCidadeProvedor.AfterLoadDFMValues;
    tblCidadesProvedor.AfterLoadDFMValues;
    wlcCidadesProvedor.AfterLoadDFMValues;
    pnlCidades.AfterLoadDFMValues;
    cbPageSizeCidades.AfterLoadDFMValues;
    cidades_search.AfterLoadDFMValues;
    tblCidades.AfterLoadDFMValues;
    wlcCidades.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    ProvedoresDataset.AfterLoadDFMValues;
    ProvedoresDatasetid.AfterLoadDFMValues;
    ProvedoresDatasetnome.AfterLoadDFMValues;
    ProvedoresDatasethomologado.AfterLoadDFMValues;
    ProvedoresDatasetinclusao.AfterLoadDFMValues;
    ProvedoresDatasetalteracao.AfterLoadDFMValues;
    XDataClientProvedoresGet.AfterLoadDFMValues;
    XDataClientProvedoresDelete.AfterLoadDFMValues;
    dtsCidadesProvedor.AfterLoadDFMValues;
    cdsCidadesProvedor.AfterLoadDFMValues;
    cdsCidadesProvedorID.AfterLoadDFMValues;
    cdsCidadesProvedorNome.AfterLoadDFMValues;
    cdsCidadesProvedorCodigoIBGE.AfterLoadDFMValues;
    cdsCidadesProvedorufSigla.AfterLoadDFMValues;
    cdsCidadesProvedorprovedor_id.AfterLoadDFMValues;
    tmrConsultaCidadesProvedor.AfterLoadDFMValues;
    dtsCidades.AfterLoadDFMValues;
    cdsCidades.AfterLoadDFMValues;
    cdsCidadesID.AfterLoadDFMValues;
    cdsCidadesNome.AfterLoadDFMValues;
    cdsCidadesCodigoIBGE.AfterLoadDFMValues;
    cdsCidadesufSigla.AfterLoadDFMValues;
    cdsCidadesprovedor_id.AfterLoadDFMValues;
    cdsCidadesprovedornome2.AfterLoadDFMValues;
    tmrConsultaCidades.AfterLoadDFMValues;
  end;
end;

end.
